;
define("facets_items_collection.tpl", function(){});

